<script setup>
import { computed } from 'vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { useConversationLabels } from 'dashboard/composables/useConversationLabels';
import { useHiddenUi } from 'dashboard/composables/useHiddenUi';

const IARA_LABEL = 'assistente_iara';

const { savedLabels, addLabelToConversation, removeLabelFromConversation } =
  useConversationLabels();
const { isHidden } = useHiddenUi();

const isActive = computed(() => savedLabels.value.includes(IARA_LABEL));

const toggle = () => {
  if (isActive.value) {
    removeLabelFromConversation(IARA_LABEL);
  } else {
    addLabelToConversation({ title: IARA_LABEL });
  }
};
</script>

<template>
  <button
    v-if="!isHidden('actionButtons', 'iaraToggle')"
    type="button"
    class="flex items-center gap-2 w-full px-3 py-2 mb-4 rounded-lg text-white font-medium transition-colors"
    :class="
      isActive
        ? 'bg-green-600 hover:bg-green-700'
        : 'bg-red-600 hover:bg-red-700'
    "
    @click="toggle"
  >
    <Icon icon="i-lucide-bot" class="size-4" />
    <span>Assistente IAra</span>
    <span class="ml-auto text-xs uppercase">{{ isActive ? 'On' : 'Off' }}</span>
  </button>
</template>
